import LoadingTable from 'components/LoadingTable';
import SelectableField from 'components/SelectableField';
import TableNavigator from 'components/TableNavigator';
import TableResults from 'components/TableResults';
import useActions from 'hooks/useActions';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PEMemberDetails from './MemberDetails';
import useQueryList from 'hooks/useQuery';
import SingleFilter from 'components/SingleFilter';

const { default: InformationTab } = require('components/InformationTab');
const { connect } = require('react-redux');

function mapStateToProps(state) {
    return {
        members: state.PEMembers.members,
        page: state.PEMembers.page,
        per_page: state.PEMembers.per_page,
        total: state.PEMembers.total,
        total_pages: state.PEMembers.total_pages,
        isLoading: state.PEMembers.isLoadingMembers,
        selectedMember: state.PEMembers.selectedMember,
        brandsFilter: state.PEMembers.brandsFilter,
        brandsOptions: state.PEBrands.brandsOptions,
        selectedRegionFilter: state.user.selectedRegion,
    };
}

const PEMembers = connect(mapStateToProps)(function (props) {
    const {
        members,
        page,
        per_page,
        total,
        total_pages,
        isLoading,
        selectedMember,
        brandsFilter,
        brandsOptions,
        selectedRegionFilter,
    } = props;

    const [detailComponent, setDetailComponent] = useState(null);

    const { id } = useParams();
    const { term: searchTerm }  = useQueryList(['term']);
    const navigate = useNavigate();

    const {
        PE_FETCH_MEMBERS_REQUEST,
        PE_GET_MEMBER_REQUEST,
        PE_SELECT_MEMBER,
        PE_SELECT_MEMBER_BRANDS_FILTER
    } = useActions();

    function onNext() {
        PE_FETCH_MEMBERS_REQUEST({
            page: page + 1,
            per_page,
            searchTerm,
            brand: brandsFilter,
        });
    }

    function onPrev() {
        PE_FETCH_MEMBERS_REQUEST({
            page: page - 1,
            per_page,
            searchTerm,
            brand: brandsFilter,
        });
    }

    function onPageSelected(pageSelected) {
        PE_FETCH_MEMBERS_REQUEST({
            page: pageSelected,
            per_page,
            searchTerm,
            brand: brandsFilter,
        });
    }
    useEffect(() => {
        PE_FETCH_MEMBERS_REQUEST({
            per_page,
            page,
            searchTerm,
            brand: brandsFilter,
        });
        // eslint-disable-next-line
    }, [brandsFilter, selectedRegionFilter]);

    function onDetailSelection(member) {
        setDetailComponent(null);
        PE_SELECT_MEMBER(member);
        if (member) {
            navigate(`/program-engine/members/${member.id}`);
        } else {
            PE_FETCH_MEMBERS_REQUEST({
                per_page,
                page,
                searchTerm,
                brand: brandsFilter,
            });
            navigate(`/program-engine/members`);
        }
    }

    function onPerPageSelected({ perPage }) {
        PE_FETCH_MEMBERS_REQUEST({ per_page: perPage, searchTerm, brand: brandsFilter, });
    }

    useEffect(() => {
        if (selectedMember) {
            setDetailComponent(<PEMemberDetails />);
        } else {
            setDetailComponent(null);
        }
    }, [selectedMember]);

    useEffect(() => {
        if (id) {
            try {
                PE_GET_MEMBER_REQUEST(id);
            } catch (err) {
                console.log(err);
            }
        } else {
            PE_SELECT_MEMBER(null);
            setDetailComponent(null);
        }
        // eslint-disable-next-line
    }, [id]);

    useEffect(() => {
        PE_FETCH_MEMBERS_REQUEST({searchTerm, brand: brandsFilter});
        // eslint-disable-next-line
    }, []);

    function filters() {
        return [
            <SingleFilter
                selectedValue={brandsFilter}
                options={[
                    { value: 'all', label: 'All Brands' },
                    ...brandsOptions,
                ]}
                onSelect={(value) => PE_SELECT_MEMBER_BRANDS_FILTER(value)}
            />,
        ];
    }

    function DataTable() {
        return (
            <section>
                <TableResults results={total} />
                <LoadingTable isLoading={isLoading}>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Brand</th>
                            <th>User ID</th>
                        </tr>
                    </thead>
                    <tbody>
                        {members.map((member) => (
                            <tr key={`member-${member.id}`}>
                                <td>
                                    <SelectableField
                                        text={member.name}
                                        url={`/program-engine/members/${member.id}`}
                                    />
                                </td>
                                <td>
                                    <SelectableField
                                        text={member.email}
                                        url={`/program-engine/members/${member.id}`}
                                    />
                                </td>
                                <td>
                                    {member.brand_ident}
                                </td>
                                <td>{member.brand_user_id}</td>
                            </tr>
                        ))}
                    </tbody>
                </LoadingTable>
                <TableNavigator
                    currentPage={page}
                    totalPages={total_pages}
                    onNext={onNext}
                    onPrev={onPrev}
                    onPageSelected={onPageSelected}
                />
            </section>
        );
    }

    return (
        <InformationTab
            sectionName="Members"
            subsectionName={selectedMember?.name}
            dataTable={<DataTable />}
            showPrograms={false}
            onDetailSelected={onDetailSelection}
            onPerPageSelected={onPerPageSelected}
            perPage={per_page}
            detailComponent={detailComponent}
            showSearchField={true}
            customFilters={filters()}
        />
    );
});

export default PEMembers;
